import {
  IFeatureModalData,
  IControlButtonTexts
} from 'module/productfeaturemodal/productfeaturemodal.types'

export const aflMint2026FeatureModalLink = '/packs'

export const aflMint2026FeatureModalData: IFeatureModalData[] = [
  {
    image: '/assets/Image/AFL-Mint-Popup.jpg',
    tag: 'IMPORTANT UPDATE',
    heading: '2026 AFL Mint Season Update',
    body: `The 2026 season marks the final year of new AFL Mint releases and platform competitions. We're committed to delivering a strong and celebratory season for all collectors.`
  },
  {
    image: '/assets/Image/AFL-Mint-Popup.jpg',
    tag: 'YOUR MOMENTS',
    heading: 'What happens to your collection?',
    body: 'All AFL Mint Moments will remain as historical digital collectibles on the blockchain and can continue to be traded via supported third-party marketplaces. We are planning to migrate Moments from Flow blockchain to Base blockchain to enable better on- and off-ramp support.'
  },
  {
    image: '/assets/Image/AFL-Mint-Popup.jpg',
    tag: '2026 SEASON',
    heading: 'New competitions and rewards',
    body: (
      <div>
        <p>
          Enjoy a new predictions platform, season-long competitions with major
          prizes, and an expanded 18-Moment Rewards set. Plus, a lighter release
          schedule with lower costs per Moment.
        </p>
        <p className="mt-4">
          For more information{' '}
          <a
            href="https://challenges.aflmint.com.au/articles/2026-afl-mint-update"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue3"
          >
            read here
          </a>
          .
        </p>
      </div>
    )
  }
]

export const aflMint2026ControlButtonTexts: IControlButtonTexts = {
  prev: 'Back',
  next: 'Next',
  end: `Let's Go`
}
